export default __webpack_public_path__ + "static/media/154.fddfbc4e.jpg";